import { Routes } from '@angular/router';
import { AdminDashboardComponent } from './pages/dashboard/admin-dashboard.component';
import { ProfileComponent } from './pages/profile/profile.component';
import { FormElementsComponent } from './pages/forms/form-elements/form-elements.component';
import { BasicTablesComponent } from './pages/tables/basic-tables/basic-tables.component';
import { BlankComponent } from './pages/blank/blank.component';
import { NotFoundComponent } from './pages/other-page/not-found/not-found.component';
import { AppLayoutComponent } from './shared/layout/app-layout/app-layout.component';
import { InvoicesComponent } from './pages/invoices/invoices.component';
import { LineChartComponent } from './pages/charts/line-chart/line-chart.component';
import { BarChartComponent } from './pages/charts/bar-chart/bar-chart.component';
import { AlertsComponent } from './pages/ui-elements/alerts/alerts.component';
import { AvatarElementComponent } from './pages/ui-elements/avatar-element/avatar-element.component';
import { BadgesComponent } from './pages/ui-elements/badges/badges.component';
import { ButtonsComponent } from './pages/ui-elements/buttons/buttons.component';
import { ImagesComponent } from './pages/ui-elements/images/images.component';
import { VideosComponent } from './pages/ui-elements/videos/videos.component';
import { SignInComponent } from './pages/auth-pages/sign-in/sign-in.component';
import { SignUpComponent } from './pages/auth-pages/sign-up/sign-up.component';
import { CalenderComponent } from './pages/calender/calender.component';
import { RoleComponent } from './user/role/role.component';
import { MechanicsListComponent } from './mechanicsManagement/mechanics-list/mechanics-list.component';
import { MechanicsDetailsComponent } from './mechanicsManagement/mechanics-details/mechanics-details.component';
import { BookingsListComponent } from './bookingsManagement/bookings-list/bookings-list.component';
import { BookingsDetailsComponent } from './bookingsManagement/bookings-details/bookings-details.component';
import { ReportsComponent } from './reports/reports.component';
import { PromotionsListComponent } from './promotionsManagement/promotions-list/promotions-list.component';
import { SettingsListComponent } from './settingsManagement/settings-list/settings-list.component';
import { CommissionsComponent } from './settingsManagement/commissions/commissions.component';
import { TicketsListComponent } from './ticketsManagement/tickets-list/tickets-list.component';
import { ServicesListComponent } from './servicesManagement/services-list/services-list.component';
import { RefundsListComponent } from './refundsManagement/refunds-list/refunds-list.component';
import { SosListComponent } from './sosManagement/sos-list/sos-list.component';
import { authGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    component: AppLayoutComponent,
    canActivate: [authGuard],
    children: [
      {
        path: '',
        component: AdminDashboardComponent,
        pathMatch: 'full',
        title: 'Dashboard | Mobile Mechanics Admin',
      },
      {
        path: 'calendar',
        component: CalenderComponent,
        title: 'Calendar | Mobile Mechanics Admin'
      },
      {
        path: 'profile',
        component: ProfileComponent,
        title: 'Profile | Mobile Mechanics Admin'
      },
      {
        path: 'form-elements',
        component: FormElementsComponent,
        title: 'Form Elements | Mobile Mechanics Admin'
      },
      {
        path: 'basic-tables',
        component: BasicTablesComponent,
        title: 'Basic Tables | Mobile Mechanics Admin'
      },
      {
        path: 'blank',
        component: BlankComponent,
        title: 'Blank | Mobile Mechanics Admin'
      },
      {
        path: 'invoice',
        component: InvoicesComponent,
        title: 'Invoices | Mobile Mechanics Admin'
      },
      {
        path: 'line-chart',
        component: LineChartComponent,
        title: 'Line Chart | Mobile Mechanics Admin'
      },
      {
        path: 'bar-chart',
        component: BarChartComponent,
        title: 'Bar Chart | Mobile Mechanics Admin'
      },
      {
        path: 'alerts',
        component: AlertsComponent,
        title: 'Alerts | Mobile Mechanics Admin'
      },
      {
        path: 'avatars',
        component: AvatarElementComponent,
        title: 'Avatars | Mobile Mechanics Admin'
      },
      {
        path: 'badge',
        component: BadgesComponent,
        title: 'Badges | Mobile Mechanics Admin'
      },
      {
        path: 'buttons',
        component: ButtonsComponent,
        title: 'Buttons | Mobile Mechanics Admin'
      },
      {
        path: 'images',
        component: ImagesComponent,
        title: 'Images | Mobile Mechanics Admin'
      },
      {
        path: 'videos',
        component: VideosComponent,
        title: 'Videos | Mobile Mechanics Admin'
      },
      {
        path: 'user',
        component: RoleComponent,
        title: 'User Roles | Mobile Mechanics Admin'
      },
      // ── Mechanics ──────────────────────────────────────────────────────────
      {
        path: 'mechanics',
        component: MechanicsListComponent,
        title: 'Mechanics Management | Mobile Mechanics Admin'
      },
      {
        path: 'mechanics-profile/:id',
        component: MechanicsDetailsComponent,
        title: 'Mechanic Profile | Mobile Mechanics Admin'
      },
      // ── Services ───────────────────────────────────────────────────────────
      {
        path: 'services',
        component: ServicesListComponent,
        title: 'Services Management | Mobile Mechanics Admin'
      },
      // ── Bookings ───────────────────────────────────────────────────────────
      {
        path: 'bookings',
        component: BookingsListComponent,
        title: 'Bookings Management | Mobile Mechanics Admin'
      },
      {
        path: 'booking-details/:id',
        component: BookingsDetailsComponent,
        title: 'Booking Details | Mobile Mechanics Admin'
      },
      // ── Refunds ────────────────────────────────────────────────────────────
      {
        path: 'refunds',
        component: RefundsListComponent,
        title: 'Refunds Management | Mobile Mechanics Admin'
      },
      // ── Tickets ────────────────────────────────────────────────────────────
      {
        path: 'tickets',
        component: TicketsListComponent,
        title: 'Support Tickets | Mobile Mechanics Admin'
      },
      // ── SOS Alerts ─────────────────────────────────────────────────────────
      {
        path: 'sos',
        component: SosListComponent,
        title: 'SOS Alerts | Mobile Mechanics Admin'
      },
      // ── Reports ────────────────────────────────────────────────────────────
      {
        path: 'reports',
        component: ReportsComponent,
        title: 'Reports & Analytics | Mobile Mechanics Admin'
      },
      // ── Promotions ─────────────────────────────────────────────────────────
      {
        path: 'promotions',
        component: PromotionsListComponent,
        title: 'Promotions Management | Mobile Mechanics Admin'
      },
      // ── Settings ───────────────────────────────────────────────────────────
      {
        path: 'settings',
        component: SettingsListComponent,
        title: 'Settings Management | Mobile Mechanics Admin'
      },
      // ── Commissions ────────────────────────────────────────────────────────
      {
        path: 'commissions',
        component: CommissionsComponent,
        title: 'Commissions Management | Mobile Mechanics Admin'
      }
    ]
  },
  // ── Auth pages (no guard) ─────────────────────────────────────────────────
  {
    path: 'signin',
    component: SignInComponent,
    title: 'Sign In | Mobile Mechanics Admin'
  },
  {
    path: 'signup',
    component: SignUpComponent,
    title: 'Sign Up | Mobile Mechanics Admin'
  },
  // ── 404 ───────────────────────────────────────────────────────────────────
  {
    path: '**',
    component: NotFoundComponent,
    title: '404 Not Found | Mobile Mechanics Admin'
  },
];
